export enum ConciergeInvoiceTypeEnum {
  New = 1,
  Additional = 2,
}
